module.exports = __webpack_public_path__ + "media/application/images/2018/my-consumer-add-plus-3c98499aa13b8fe5f88b0183c659065b.svg";